// extracted by mini-css-extract-plugin
module.exports = {"main_container":"addNewNote_main_container__2aBCz","new_note__container":"addNewNote_new_note__container__2MPuX","new_note__logo":"addNewNote_new_note__logo__2YGBo"};